import React, { useState, useEffect, useContext } from "react"
import { SectionContext } from "../context/sectionContext"
import { PageContext } from "../context/pageContext"
import { JourneyContext } from "../context/journeyContext"
import {
  generateBI,
  fetchAllJourneyData,
  pdfDownload,
  uploadDocument,
  saveApplication,
  fetchApplicationDetails,
  sendEmailBI,
  s3uploadPdfBI,
} from "../../services/apiservice"
import {
  getDateInFormat,
  getStateFromCode,
  getAge,
  findCurrentJourneyCode,
  getValueFromLookup,
  findRiderSA,
  getSourceFromChannel
} from "../services/helperFunctions"
import {
  errorToastr,
  successToastr,
  clearToastr,
} from "../../services/error-handler"
import * as moment from "moment"
import { wordCapital, lineCapital, applyComma } from '../../shared/functions'


const BenefitIllustrationGSP = (props) => {

  const [sectionState, setSectionState] = useContext(SectionContext)
  const [pageState, setPageState] = useContext(PageContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [allJourneyData, setAllJourneyData] = useState()
  const [biApiData, setBiApiData] = useState()
  const [pdfData, setPdfData] = useState("")
  const [proceedWithOption, setProceedWithOption] = useState()

  async function downloadLinkOfPdf(Base64Pdf) {
    const fileName = `GuaranteedSaving_Plan_${journeyState.applicationNo}.pdf`
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      var byteCharacters = atob(Base64Pdf)
      var byteNumbers = new Array(byteCharacters.length)
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      var byteArray = new Uint8Array(byteNumbers)
      var blob = new Blob([byteArray], { type: "application/pdf" })
      window.navigator.msSaveOrOpenBlob(blob, fileName)
      return
    }

    // For Other Browsers
    const linkSource = "data:application/pdf;base64," + Base64Pdf
    const link = document.createElement("a")
    link.href = linkSource
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    link.remove()

    window.addEventListener(
      "focus",
      function () {
        URL.revokeObjectURL(link.href)
      },
      { once: true }
    )
  }
  const downloadPdf = async () => {
    let sendEmailPdfData = pdfData
    if (!sendEmailPdfData) {
      if (!biApiData) {
        return
      } else {
        let pdfResult = await pdfDownload({
          applicationNumber: journeyState.applicationNo,
          TID: biApiData.TransactionId || "",
        })
        setPdfData(pdfResult.data.Base64Pdf)
        sendEmailPdfData = pdfResult.data.Base64Pdf
      }
    }
    downloadLinkOfPdf(sendEmailPdfData)
  }
  const printPdf = async () => {
    if (pdfData) {
      printPdf1(pdfData)
    } else {
      let pdfResult = await pdfDownload({
        applicationNumber: journeyState.applicationNo,
        TID: biApiData.TransactionId || "",
      })
      setPdfData(pdfResult.data.Base64Pdf)
      printPdf1(pdfResult?.data?.Base64Pdf)
    }

    function printPdf1(base64Data) {
      const newWindow = window.open("", "", "width=100, height=100")
      if (newWindow) {
        const document = newWindow.document.open()
        document.close()
        newWindow.moveTo(0, 0)
        newWindow.resizeTo(window.screen.width, window.screen.height)
        const contentType = "application/pdf"
        const b64Data = base64Data
        const blob = b64toBlob(b64Data, contentType)
        const blobUrl = URL.createObjectURL(blob)
        document.write(`<iframe id="pdfDocument"
        src="${blobUrl}" 
        width="100%"
        height="100%"
        frameBorder="0" ></iframe>`)
        const docs = document.getElementById("pdfDocument")
        setTimeout(() => {
          docs.contentWindow.print()
        }, 1000)
      }
    }
    function b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || ""
      sliceSize = sliceSize || 512

      var byteCharacters = atob(b64Data)
      var byteArrays = []

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize)

        var byteNumbers = new Array(slice.length)
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }

        var byteArray = new Uint8Array(byteNumbers)

        byteArrays.push(byteArray)
      }

      var blob = new Blob(byteArrays, { type: contentType })
      return blob
    }
  }
  const sendEmail = async () => {
    let sendEmailPdfData = pdfData
    if (!sendEmailPdfData) {
      if (!biApiData) {
        return
      } else {
        let pdfResult = await pdfDownload({
          applicationNumber: journeyState.applicationNo,
          TID: biApiData.TransactionId || "",
        })
        setPdfData(pdfResult.data.Base64Pdf)
        sendEmailPdfData = pdfResult.data.Base64Pdf
      }
    }
    let payload = {
      journeyId: journeyState.journeyId,
      module: "BIEMAIL",
      BIPDF: sendEmailPdfData,
    }
    sendEmailBI(payload).then(res => {
      console.log(res, "emailRes")
      if (res?.status) {
        successToastr(res.message)
      } else {
        errorToastr(res.message)
      }
    })
  }

  //async function to make API call
  const getData = async () => {
    let applicationDetailsPayload = {
      _id: journeyState.journeyId,
    }
    let applicationResult = await fetchApplicationDetails(
      applicationDetailsPayload
    )

    let payload = {
      journeyId: journeyState.journeyId,
      allRowData: true,
    }
    let journeyResult = await fetchAllJourneyData(payload)
    if (journeyResult?.lifeAssuredDetails?.proceedWith) {
      setProceedWithOption(journeyResult?.lifeAssuredDetails?.proceedWith)
    }
    generateBI(payload).then(async data => {
      console.log(journeyResult, data, "vjhdvhhs")
      setAllJourneyData(journeyResult)
      setJourneyState(prev => {
        return {
          ...prev,
          premium: JSON.parse(data.data.BIJson)?.[0]?.BASE_PREM,
          journeyData: applicationResult.applicationData,
        }
      })
      let pdfResult = await pdfDownload({
        applicationNumber: journeyState.applicationNo,
        TID: data.data.TransactionId || "",
      })
      setPdfData(pdfResult.data.Base64Pdf)
      setBiApiData(data.data)
    })
    .catch(err => {
      console.log("error in save application of save application and call BI function")
    })
  }

  useEffect(async () => {
    await getData();
  }, [])
  

  // code of tab enter
  const handleEnterDownload = (event) => {
    if (event?.key == 'Enter') {
      downloadPdf();
    }
  }
  // code of tab enter
  const handleEnterPrint = (event) => {
    if (event?.key == 'Enter') {
      printPdf();
    }
  }
  // code of tab enter
  const handleEnterEmail = (event) => {
    if (event?.key == 'Enter') {
      sendEmail();
    }
  }
  // code of tab enter
  const handleEnterRecalculate = (event) => {
    if (event?.key == 'Enter') {
      handleReCalculate();
    }
  }


  const handleProceed = async (ev,payNowOrLater) => {
    ev.preventDefault()
    if (payNowOrLater === "now") {
      let temp = journeyState.journeySteps.pages
      let element = temp[3]
      temp.splice(3, 1)
      temp.splice(2, 0, element)

      setJourneyState(prev => {
        return {
          ...prev,
          journeySteps: {
            pages: temp,
          },
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex,
          lastPageCode: props.pageId,
          lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
          paymentStep: "N",
          journeyCode: findCurrentJourneyCode(
            props.pageId,
            props.sections[props.currentSectionIndex].sectionId
          ),
        }
      })
    }
    let sendPayload = {
      applicationData: journeyState.journeyData,
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: props.currentPageIndex,
        lastSection: props.currentSectionIndex,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        proposalEntryId: journeyState.proposalEntryId,
        lastPageCode: props.pageId,
        paymentStep: payNowOrLater === "now" ? "N" : "L",
        premium: journeyState.premium,
        planOption: journeyState.planOption,
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
      },
      base64Data: pdfData,
    }
    saveApplication(sendPayload).then(res => {
      console.log(res, "application response")
      props.setCurrentSectionIndex(0) // this moves to first section of next page
      props.setCurrentPageIndex(prev => prev + 1)
    }).catch(err => {
      console.log(err, "err in saveApplication benefitIllustrationGSP")
    })
  }

  const handleReCalculate = () => {
    if (proceedWithOption === "manually") {
      props.setCurrentPageIndex(0)
      props.setCurrentSectionIndex(0)
      const tempPage = journeyState.journeyData[0]
      setPageState(prev => {
        return {
          ...prev,
          pageId: tempPage.pageId,
          pageData: tempPage.pageData,
        }
      })
      const tempState = journeyState.journeyData[0].pageData[0]
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: tempState.sectionId,
          sectionData: tempState.sectionData,
        }
      })
    }
  }


  return (
    <div>
      <div className="landing-page1-design">
        <div className="container">
          {allJourneyData && biApiData && (

            <div className="row">
              <form name="calculatePremium" method="POST" id="calculatePremium" noValidate="novalidate">
                <div className="col-md-12">
                  <div className="iselect-box-design space-cover">
                    <div className="iselect-padding">
                      <h1 className="iselect-heading line-large">Benefit Illustration for Canara HSBC Life Insurance Company Limited Guaranteed Savings Plan</h1>
                      <span className="subhead">UIN: 136N066V02</span> </div>
                    <div className="app-quatation ls1">
                      <div className="application-design-number">Application Number: {journeyState.applicationNo}</div>
                      <p className="quotation">Date of Quotation: {moment.unix(Date.now()/1000).utcOffset("+05:30").format("MMMM DD, YYYY")}</p>
                    </div>
                    <div className="iselect-padding">
                      <div className="bi-summary">
                        <div className="auther-description">
                          <h3>Dear{" "}
                            <b>
                              {
                                allJourneyData.lifeAssuredDetails.gender.toUpperCase() == "M" || allJourneyData.lifeAssuredDetails.gender.toUpperCase() == "T" ? `Mr. ` : `Ms. `
                              }
                              {wordCapital(allJourneyData?.lifeAssuredDetails?.fullName ?? '')}
                            </b>{" "}</h3>
                          <p className="benefit-title">Thank you for showing interest in Canara HSBC Life Insurance Company Limited Guaranteed Savings Plan. Based on the details provided by you, and reproduced below, the illustration customised to your requirements is appended. </p>
                          <p className="benefit-title"> Please note that this illustration is indicative and the actual values may vary depending on performance of the participating fund managed by the Company.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row iselect-padding">
                  <div className="col-md-12 mt pl-pr">
                    <div className="iselect-box-design">
                      <div className="iselect-padding bi-summary-two-box q3-mt2 design-libe">
                        <div className="col-md-12 col-xs-12 pl">
                          <h3 className="org">Personal Details of Life to be Assured</h3>
                        </div>
                        <div className="col-md-6 col-xs-12 pl-pr pr-30">
                          <div className="bi-summary-list-box">
                            <label>Date of Birth</label>
                            <div className="box-stylish name">{getDateInFormat(
                              allJourneyData.lifeAssuredDetails.dob
                            )?.toUpperCase()}</div>
                          </div>
                        </div>
                        <div className="col-md-6 col-xs-12 pl-pr pl-30">
                          <div className="bi-summary-list-box">
                            <label>Age</label>
                            <div className="box-stylish dateofbirth">{JSON.parse(biApiData.BIJson)?.[0]
                              .LI_ATTAINED_AGE ?? "NA"}</div>
                          </div>
                        </div>
                        <div className="col-md-6 col-xs-12 pl-pr pr-30">
                          <div className="bi-summary-list-box" style={{fontSize: "14px"}}>
                            <label>Designation</label>
                            <div className="box-stylish gender" >{lineCapital(getValueFromLookup("natureOfOccupation", allJourneyData?.lifeAssuredDetails?.employmentDetails?.natureOfOccupation))}</div>
                          </div>
                        </div>
                        <div className="col-md-6 col-xs-12 pl-pr pl-30">
                          <div className="bi-summary-list-box">
                            <label>Gender</label>
                            <div className="box-stylish dateofbirth age">{lineCapital(getValueFromLookup(
                              "gender",
                              allJourneyData.lifeAssuredDetails.gender
                            ) ?? '') || "NA"}</div>
                          </div>
                        </div>
                        <div className="col-md-6 col-xs-12 pl-pr pr-30">
                          <div className="bi-summary-list-box">
                            <label>Date of Illustration </label>
                            <div className="box-stylish smoke1121">{moment.unix(Date.now()/1000).utcOffset("+05:30").format("MMMM DD, YYYY")}</div>
                          </div>
                        </div>
                        <div className="col-md-6 col-xs-12 pl-pr pl-30">
                          <div className="bi-summary-list-box">
                            <label>Sum Assured(<span className="fa fa-rupee" />)</label>
                            <div className="box-stylish sumAssured"><span className="fa fa-rupee" /> {applyComma(allJourneyData.productDetails.sumAssured) || "NA"}</div>
                          </div>
                        </div>
                        <div className="col-md-6 col-xs-12 pl-pr pr-30">
                          <div className="bi-summary-list-box">
                            <label>Illustration for Standard Life </label>
                            <div className="box-stylish coption">Illustration for Standard Life</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 space-design bi-mt-5 pl-pr">
                    <div className="two-box-right-side">
                      <div className="iselect-box-design">
                        <div className="iselect-padding bi-summary-two-box design-libe">
                          <div className="col-md-12 col-xs-12 pl-pr">
                            <h3 className="org">Plan Details</h3>
                          </div>
                          <div className="col-md-6 col-xs-12 pl-pr pr-30">
                            <div className="bi-summary-list-box">
                              <label>Proposal Number </label>
                              <div className="box-stylish fname">{journeyState.applicationNo}</div>
                            </div>
                          </div>
                          <div className="col-md-6 col-xs-12 pl-pr pl-30">
                            <div className="bi-summary-list-box">
                              <label>Name of the Plan </label>
                              <div className="box-stylish dob">Canara HSBC Life Insurance Company Limited Guaranteed Savings Plan</div>
                            </div>
                          </div>
                          <div className="col-md-6 col-xs-12 pl-pr pr-30">
                            <div className="bi-summary-list-box">
                              <label>Plan Option </label>
                              <div className="box-stylish spouseg">{lineCapital(getValueFromLookup("planOption", allJourneyData?.productDetails?.planOption))}</div>
                            </div>
                          </div>
                          <div className="col-md-6 col-xs-12 pl-pr pl-30">
                            <div className="bi-summary-list-box">
                              <label>Policy Term</label>
                              <div className="box-stylish spousesa">{allJourneyData?.productDetails?.policyTerm || "NA"}</div>
                            </div>
                          </div>
                          <div className="col-md-6 col-xs-12 pl-pr pr-30">
                            <div className="bi-summary-list-box ">
                              <label>Premium Payment Term </label>
                              <div className="box-stylish"> {allJourneyData?.productDetails
                                ?.premiumPaymentTerm || "NA"}</div>
                            </div>
                          </div>
                          <div className="col-md-6 col-xs-12 pl-pr pl-30">
                            <div className="bi-summary-list-box">
                              <label>Premium Payment Frequency </label>
                              <div className="box-stylish coverage"> {lineCapital(getValueFromLookup(
                                "premiumFrequency",
                                allJourneyData.productDetails.premiumFrequency
                              ) ?? '') || "NA"}</div>
                            </div>
                          </div>
                          <div className="col-md-6 col-xs-12 pl-pr pr-30">
                            <div className="bi-summary-list-box">
                              <label>Annualised Premium </label>
                              <div className="box-stylish bpospous">10,05,460</div>
                            </div>
                          </div>
                          <div className="col-md-6 col-xs-12 pl-pr pl-30">
                            <div className="bi-summary-list-box">
                              <label>Installment Premium for Year 1 (without Goods and Services Tax &amp; Cess (es)/ levy, if any) </label>
                              <div className="box-stylish coverage">₹5,460</div>
                            </div>
                          </div>
                          <div className="col-md-6 col-xs-12 pl-pr pr-30">
                            <div className="bi-summary-list-box">
                              <label>Installment Premium from Year 2 onwards (without Goods and Services Tax &amp; Cess (es)/ levy, if any): </label>
                              <div className="box-stylish bpospous">₹9,460</div>
                            </div>
                          </div>
                          <div className="col-md-6 col-xs-12 pl-pr pl-30">
                            <div className="bi-summary-list-box">
                              <label>Installment Premium for Year 1 (with Goods and Services Tax &amp; Cess (es)/ levy, if any): </label>
                              <div className="box-stylish coverage">₹9,960</div>
                            </div>
                          </div>
                          <div className="col-md-6 col-xs-12 pl-pr pr-30">
                            <div className="bi-summary-list-box">
                              <label>Installment Premium from Year 2 onwards (with Goods and Services Tax &amp; Cess (es) levy, if any): </label>
                              <div className="box-stylish bpospous">₹8,098</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 bi-mt-5 pl-10 pt-20 pl-pr">
                    <div className="total-mt-design" style ={{
                         backgroundColor: "#eb7f25",
                         padding: "10px",
                     
                         textAlign: "center",
                         fontweight: "bold",
                         color: "#fff",
                         borderradius: "7px"
                    

                    }}> <span><strong style={{fontSize:"20px"}}>Guaranteed Maturity Benefit - 323436</strong></span> </div>
                  </div>
                  <div className="clearfix" />
                  <div className="col-md-12 incleasing  pl-pr pt-10 pl">
                    <p className="bi-ml2">*This is applicable only for Level Cover option. For increasing cover option these amounts will increase as per terms and conditions of
                      the Policy. </p>
                  </div>
                  <div className="col-md-12">
                    <div className="transactionDetailsWrap">
                      <div className="detailContentWrap">
                        <div className="row">
                          <div className="buttonWrap" >
                             <div className="button submit-btn"
                              style={{ cursor: "pointer",borderRadius:"80px" }}
                              tabIndex='0'
                              onKeyPress={(e) => handleEnterDownload(e)}
                              onClick={downloadPdf}
                            >
                              <a style={{borderRadius:"50px"}}>Download</a>
                            </div>
                            <div className="button submit-btn"
                        style={{ cursor: "pointer",borderRadius:"80px" }}
                        tabIndex='0'
                        onKeyPress={(e)=>handleEnterPrint(e)}
                        onClick={printPdf}
                      >
                        <a style={{borderRadius:"50px"}} >Print</a>
                      </div>
                            <div className="button submit-btn"
                        style={{ cursor: "pointer" ,borderRadius:"80px"}}
                        tabIndex='0'
                        onKeyPress={(e)=>handleEnterEmail(e)}
                        onClick={sendEmail}
                      >
                        <a style={{borderRadius:"50px"}}>Email</a>
                      </div>
                            <div className="button submit-btn"
                        style={{
                          borderRadius:"80px",cursor:
                            proceedWithOption === "manually"
                              ? "pointer"
                              : "default",
                        }}
                        tabIndex="0"
                        disabled={
                          proceedWithOption === "manually" ? false : true
                        }
                        onKeyPress={(e)=>handleEnterRecalculate(e)}
                        onClick={handleReCalculate}
                      >
                        <a style={{borderRadius:"50px"}}>Re-Calculate</a>
                      </div>
                          </div>
                        </div>
                        <div className="row iAgree">
                          <div className="form-group">
                            <div className="inner-addon left-addon">
                              <div className="checkbox1">
                                <input name="checkboxG6" id="checkboxG6" className="css-checkbox" type="checkbox" defaultChecked />
                                <label htmlFor="checkboxG6" className="css-label"> I agree to the Risk Factors and Disclosures mentioned below.</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                
                </div>
                <div className="clearfix" />
                <div className="iselect-mg-bottom mt-30 pt-20">
                  <div className="col-md-12">
                    <div className="but-center text-right" style = {{display:"flex",justifyContent:"right"}}>
                      <div className="submit-btn cen" style={{borderradius:"50px"}}> <a aria-hidden="true" onClick={(e)=>handleProceed(e,"later")}> PAY LATER </a> </div>
                      <input className="previous-btn cen text-uppercase ls2" style={{ color: 'white', padding: '14px 40px', border: 'none', backgroundColor: '#db0011 !important' }} type="submit" Value="Pay Now" onClick={(e)=>handleProceed(e,"now")}/>
                    </div>
                  </div>
                </div>
                <div className="iselect-mg-bottom mt-20 ">
                  <div className="col-md-12 col-xs-12 pr-30"> <label className="title-bg"><strong>Disclaimers:</strong></label>
                    <p>-  Canara HSBC Life Insurance Company Limited Guaranteed Savings Plan is an Individual Non-Linked Non-Par Life Insurance Savings cum Protection Plan.</p>
                    <p>-  Tax Benefits under the plan will be as per the prevailing Income Tax laws and are subject to amendments from time to time. For tax related queries, contact your independent tax advisor.</p>
                    <p>-  The above illustration takes into account currently applicable Goods and Services Tax including applicable cess(es)/other levy, if any. However, the applicable taxes may change from time to time and premium payable will change accordingly.</p>
                    <p>- Issuance of the policy and acceptance of the risk is completely at the discretion of the Canara HSBC Life Insurance Company Limited ("Company") and this premium quotaton would in no way be tantamount to acceptance of risk by the Company.</p>
                    <p>-  The above premium is for a healthy individual. Your application will be assessed as per board approved underwriting guidelines of the company. Basis underwriting, it may result in an extra premium to be paid, which shall be borne by you.</p>
                    <p>-  For more details on risk factors, terms and conditions, please read the sales brochure carefully before concluding a sale.</p>
                    <p>-  The mentioned quote is valid till next birthday or 30 days from the quote generation date whichever is earlier.</p>
                    <p>-  For any further clarifications, please free to contact us at {getSourceFromChannel(journeyState.channel) === "U" ?  "1800-258-5899" : "1800-891-0003"} or email us at customerservice@canarahsbclife.in or visit our website <a href>www.canarahsbclife.com</a>.</p>
                  </div>
                </div>
              </form>
            </div>
          )}

        </div>
      </div>
      <div className="clearfix" />

      <link href="js/validate/select2.min.css" rel="stylesheet" />
    </div>
  )
}
export default BenefitIllustrationGSP


